import { useGetUserPermsQuery } from '@/permissions/permissionApi';
import React from 'react';
import { REFRESH_PERMISSIONS } from '@/permissions/constants';
import { pathOr, pipe, split, uncurryN } from 'ramda';
import { useDatasourceId } from '@/hooks';

const readPermission = uncurryN(2, pipe(split('.'), pathOr(false)));

export const usePermission = (permissionPath: string) => {
  const datasourceId = useDatasourceId();
  const { data, refetch } = useGetUserPermsQuery({
    datasourceId,
  });

  React.useEffect(() => {
    window.addEventListener(REFRESH_PERMISSIONS, refetch);

    return () => window.removeEventListener(REFRESH_PERMISSIONS, refetch);
  }, [refetch]);

  return readPermission(permissionPath, data);
};
